export interface MvMMarchLocksState {
  /**
   * Pending attack id → character instance ids deployed on that march (leader/joiner roster).
   * Supplements server `isUsing`, which may stay false until hex battle is created.
   */
  lockedCharacterIdsByAttackId: Record<string, string[]>
}

export const initialMvMMarchLocksState: MvMMarchLocksState = {
  lockedCharacterIdsByAttackId: {},
}
